// extracted by mini-css-extract-plugin
export default {"main":"CircularGuage_main__GiZW6","info":"CircularGuage_info__FQnst","fill":"CircularGuage_fill__zpuqY"};